module.exports = __webpack_public_path__ + "img/image1.9bcdf57f.jpeg";